var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"items-center"},[_vm._t("icon"),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }